"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStatus = exports.hidePlayerData = void 0;
var vue_1 = require("vue");
var ActionLabel_1 = require("./ActionLabel");
var Button_1 = require("../common/Button");
var PlayerTimer_1 = require("./PlayerTimer");
var hidePlayerData = function (root, playerIndex) {
    root.setVisibilityState('pinned_player_' + playerIndex, false);
};
exports.hidePlayerData = hidePlayerData;
exports.PlayerStatus = vue_1.default.component('player-status', {
    props: {
        player: {
            type: Object,
        },
        activePlayer: {
            type: Object,
        },
        firstForGen: {
            type: Boolean,
        },
        actionLabel: {
            type: String,
        },
        playerIndex: {
            type: Number,
        },
    },
    components: {
        Button: Button_1.Button,
        PlayerTimer: PlayerTimer_1.PlayerTimer,
    },
    methods: {
        getLabelAndTimerClasses: function () {
            var classes = [];
            var baseClass = 'player-action-status-container';
            classes.push(baseClass);
            if (!this.player.game.gameOptions.showTimers) {
                classes.push('no-timer');
            }
            if (this.actionLabel === ActionLabel_1.ActionLabel.PASSED) {
                classes.push(baseClass + "--passed");
            }
            else if (this.actionLabel === ActionLabel_1.ActionLabel.ACTIVE || this.actionLabel === ActionLabel_1.ActionLabel.DRAFTING || this.actionLabel === ActionLabel_1.ActionLabel.RESEARCHING) {
                classes.push(baseClass + "--active");
            }
            return classes.join(' ');
        },
        getActionStatusClasses: function () {
            var classes = ['player-action-status'];
            if (this.actionLabel === ActionLabel_1.ActionLabel.NONE) {
                classes.push('visibility-hidden');
            }
            return classes.join(' ');
        },
    },
    template: "\n      <div class=\"player-status\">\n        <div class=\"player-status-bottom\">\n          <div :class=\"getLabelAndTimerClasses()\">\n            <div :class=\"getActionStatusClasses()\">{{ actionLabel }}</div>\n            <div class=\"player-status-timer\" v-if=\"player.game.gameOptions.showTimers\"><player-timer :timer=\"player.timer\"/></div>\n          </div>\n        </div>\n      </div>\n    ",
});
//# sourceMappingURL=PlayerStatus.js.map